import _Singleton from '@/tools/singleton';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _indexOf from 'lodash/indexOf';
import _isArray from 'lodash/isArray';
import _pick from 'lodash/pick';
import _replace from 'lodash/replace';
import _set from 'lodash/set';
import _slice from 'lodash/slice';
import _split from 'lodash/split';
import _reduce from 'lodash/reduce';

/** @private */
const FIRST = 0;
const SECOND = 1;

/**
 * @description
 * Тул для разбора url.
 *
 * @return {void}
 */
class URL {
  constructor(){
    this._init();
  }
  /**
  * @description
  * Разбор урла
  * @method
  * @private
  *
  */
  private _init () {
    this['location'] = window.location;
    this['keys'] = this._parseSearch();
    this['search'] = this.collectSearch(null);
    this['selectedFilter'] = this._parseSelectedFilter();

    this.parseCollection();

    return;
  };

  private _parseSearch () {
    let _search = '';
    try {
      _search = decodeURIComponent(this['location'].search.replace(/%D0&/, '&'));
    } catch {
      _search = '';
      console.warn('Невалидный гет параметр: ' + this['location'].search );
    }

    return _reduce(
      _split(_replace(_search, '?', ''), '&'),
      (result: any, part: string) => {
        const _parts = _split(part, '=');

        if (!result[_parts[FIRST]]) {
          result[_parts[FIRST]] = [];
        }
        result[_parts[FIRST]].push(this._convertValue(_parts[SECOND]));

        return result;
      },
      {}
    );

  };

  collectSearch(keys: any) {
    let _parseSearch = keys || this['keys'];

    // Если первый ключ в обьекте пустой, то выкидываем им пустую строку
    if (Object.keys(_parseSearch)[0] == '') {
      return '';
    }

    let parseSearchArray = [];

    // Собираем url
    for (let key in _parseSearch) {
      if (!_isArray(_parseSearch[key])) {
        parseSearchArray.push(`${key}=${_parseSearch[key]}`);
      }
      else {
        _forEach(_parseSearch[key],  (value: string) => {
          parseSearchArray.push(`${key}=${value}`);
        });
      }
    }

    return `?${parseSearchArray.join('&')}`;
  };

  private _parseSelectedFilter () {
    let _start = {
      characteristics: [],
      options: {},
      properties: {},
      price: {},
    };

    return _reduce(
      this['keys'],
      (result: any, values: Array<string>, key: string) => {
        let _key = null;
        let _side = null;

        if (key == 'characteristics[]') {
          result.characteristics = values;
        } else if (_includes(key, 'options')) {
          _key = _replace(key, /\D/g, '');
          result.options[_key] = values;
        } else if (_includes(key, 'properties')) {
          _side = _includes(key, 'gt') ? 'from' : 'to';

          _key = _replace(key, /\D/g, '');
          _set(result.properties, [_key, _side], values[FIRST]);
        } else if (_includes(key, 'price')) {
          _side = _includes(key, 'min') ? 'from' : 'to';
          result.price[_side] = values[FIRST];
        } else {
          result[key] = values[FIRST];
        }

        return result;
      },
      _start
    );

  };

  private _convertValue(value: string) {
    let _value = null;

    switch (value) {
      case 'true':
      _value = true;
      break;
      case 'false':
      _value = false;
      break;
      default:
      _value = value;
    }

    return _value;
  };

  /**
  * @description
  * Вытаскиваем значение ключа
  *
  * @memberof module:tools/url
  *
  */
  getKeyValue(key: string) {
    return _get(this['keys'], key + '[0]', false);
  };

  getKeysValue (keys: any) {
    return _pick(this['keys'], keys);
  };

  parseCollection () {
    let _parts = _split(this['location'], '/');
    let _index = _indexOf(_parts, 'collection') + 1; // eslint-disable-line no-magic-numbers
    let _handlers = [];

    if (_index) {
      _handlers = _slice(_parts, _index);
    }

    switch (_handlers.length) {
      case 2: // eslint-disable-line no-magic-numbers
      this['collectionFilter'] = _handlers[SECOND];
      case 1: // eslint-disable-line no-magic-numbers
      this['collection'] = _handlers[FIRST];
      break;
    }

    return;
  };
};

export default _Singleton(URL).getInstance();
